import React from 'react';
import { useHistory } from 'react-router-dom';
import { TERMS_POINTS } from '../../helpers/termsContent';
import './TermsAndConditionsPage.css';

const TermsAndConditionsPage = () => {
  const history = useHistory();

  const handleBack = () => {
    // Signup opens Terms in a new tab (target=_blank) — close that tab.
    if (window.opener) {
      window.close();
      return;
    }
    if (window.history.length > 1) {
      history.goBack();
      return;
    }
    // Last resort if the browser blocked close / no history
    window.close();
    history.replace('/access');
  };

  return (
    <div className="xk-terms-page">
      <div className="xk-terms-page__logo-wrap">
        <img
          src={`${process.env.PUBLIC_URL || ''}/XLog3D Logo_Red.png`}
          alt="XLog3D"
          className="xk-terms-page__logo"
        />
      </div>

      <div className="xk-terms-page__card">
        <div className="xk-terms-page__credits">
          <div className="xk-terms-page__credit">
            <div className="xk-terms-page__credit-label">Concept &amp; Geological Algorithm</div>
            <div className="xk-terms-page__credit-name">Yogendra Deva</div>
            <div className="xk-terms-page__credit-role">
              Consulting Engineering Geologist | Former Director (VRS), Geological Survey of India
            </div>
          </div>
          <div className="xk-terms-page__credit">
            <div className="xk-terms-page__credit-label">Project Coordination &amp; Algorithm Support</div>
            <div className="xk-terms-page__credit-name">Mugdha Patwardhan</div>
            <div className="xk-terms-page__credit-role">Consulting Engineering Geologist</div>
          </div>
          <div className="xk-terms-page__credit">
            <div className="xk-terms-page__credit-label">Software Development</div>
            <div className="xk-terms-page__credit-name">Appsphere Softwares LLP</div>
          </div>
        </div>

        <div className="xk-terms-page__box">
          <h1 className="xk-terms-page__box-title">Disclaimer &amp; Terms of Use</h1>
          <ol className="xk-terms-page__list">
            {TERMS_POINTS.map((point) => (
              <li key={point.slice(0, 48)}>{point}</li>
            ))}
          </ol>
        </div>

        <button type="button" className="xk-terms-page__back" onClick={handleBack}>
          Back
        </button>
      </div>
    </div>
  );
};

export default TermsAndConditionsPage;
